export default __webpack_public_path__ + "static/media/GBP.699f3694.svg";